<template>
  <dialog-v2
    :show="show"
    title="Agregar condiciones"
    max-width="600px"
    @close="$emit('close')"
    @save="save">
    <template slot="content">
      <v-container fluid grid-list-lg pa-0 mb-4>
        <v-layout row wrap align-center>
          <v-flex md4>
            <v-select
              v-model="form.field"
              :items="filtersMapped"
              class="grey"
              color="black"
              label="Filtros"
              flat
              solo
              autocomplete/>
          </v-flex>
          <v-flex md4>
            <v-select
              v-model="form.condition"
              :items="conditions"
              class="grey"
              color="black"
              label="Condición"
              flat
              solo
              autocomplete/>
          </v-flex>
          <v-flex md3>
            <v-select
              v-model="form.value"
              :items="valuesList"
              class="grey"
              color="black"
              label="Valor"
              flat
              solo
              autocomplete/>
          </v-flex>
          <v-flex md1 pr-0 text-xs-center>
            <v-btn @click="addItem" id="save-button" class="ma-0 k-orange-linear" depressed small>
              <v-icon small>
                fas fa-check
              </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-divider></v-divider>
      <v-layout row wrap mt-2>
        <v-flex xs12 text-xs-center>
          <v-menu offset-y>
            <v-chip slot="activator" class="my-3">
              <strong class="mr-2">Conector:</strong>
              {{ globalConnector === 'and' ? 'Y' : 'O' }}
            </v-chip>
            <v-list>
              <v-list-tile @click="globalConnector = 'and'">
                <v-list-tile-title>
                  Y
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="globalConnector = 'or'">
                <v-list-tile-title>
                  O
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-flex>
      </v-layout>
      <scrollbar style="height: 180px;">
        <v-container fluid>
          <template v-for="(item, i) in items">
            <v-layout
              :key="`vaina-${i}`"
              row
              wrap
              justify-space-between
              align-center
              text-xs-center
              class="my-2">
              <v-flex md1 text-xs-right pr-3>
                <v-icon small>
                  fas fa-filter
                </v-icon>
              </v-flex>
              <v-flex md3 text-xs-left>
                <h4 class="d-inline-block">
                  {{ getFilterTitle(item.field === 'partial_refinancing' || item.field === 'total_refinancing' ? item.field : `${item.field}_id`) }}
                </h4>
              </v-flex>
              <v-flex md2 text-xs-left>
                {{ getconditionName(item.condition) }}
              </v-flex>
              <v-flex md5>
                {{ getFilterValue(item.field === 'partial_refinancing' || item.field === 'total_refinancing' ? item.field : `${item.field}_id`) }}
              </v-flex>
              <v-flex md1>
                <v-btn
                  class="k-orange-linear"
                  @click="deleteItem(i)"
                  small
                  icon
                  round>
                  <v-icon small>
                    fas fa-times
                  </v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </template>
        </v-container>
      </scrollbar>
    </template>
  </dialog-v2>
</template>

<script>
import { setTimeout } from 'timers';
import Scrollbar from 'vue-perfect-scrollbar';
import DialogV2 from '@/components/global/DialogV2';
import filtersMixin from '@/mixins/workflowFilters';
import EventBus from '@/event-bus';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    group: {
      type: Object,
      required: true,
    },
  },
  components: {
    Scrollbar,
    DialogV2,
  },
  mixins: [
    filtersMixin,
  ],
  data() {
    const emptyForm = {
      field: '',
      condition: '',
      value: '',
    };
    return {
      emptyForm,
      form: {
        ...emptyForm,
      },
      items: [],
      globalConnector: 'and',
      logicalconditions: [
        {
          text: 'Y',
          value: 'and',
        },
        {
          text: 'O',
          value: 'or',
        },
      ],
      conditions: [
        /*
        {
          text: 'Mayor que',
          value: 'gt',
        },
        {
          text: 'Menor que',
          value: 'lt',
        },
        */
        {
          text: 'Igual a',
          value: 'eq',
        },
        {
          text: 'Diferente de',
          value: 'neq',
        },
      ],
    };
  },
  computed: {
    filtersMapped() {
      return this.filtersList.map(item => ({
        text: item.title,
        value: item.name,
      }));
    },
    valuesList() {
      return ((this.filtersList.find(item => item.name === this.form.field) || {}).items || [])
        .map(item => ({
          text: item.name,
          value: item.id,
        }));
    },
  },
  methods: {
    addItem() {
      if (this.form.field && this.form.condition && String(this.form.value).trim() !== '') {
        const item = {
          ...this.form,
        };
        if (item.field === 'partial_refinancing' || item.field === 'total_refinancing') {
          item.value = parseInt(item.value, 10);
        }
        this.items.push(item);
        this.form = {
          ...this.emptyForm,
        };
      } else {
        EventBus.$emit('modal', 'Debe rellenar todos los campos');
      }
    },
    deleteItem(i) {
      this.items.splice(i, 1);
    },
    getconditionName(value) {
      return this.conditions.find(item => item.value === value).text;
    },
    save() {
      if (this.items.length) {
        let event = 'new-filters';
        if (Object.keys(this.group).length) {
          event = 'edit-filters';
        }
        this.$emit(event, {
          connector: this.globalConnector,
          items: this.items,
        });
        this.$emit('close');
      } else {
        EventBus.$emit('modal', 'Debe activar al menos un filtro');
      }
    },
  },
  watch: {
    show() {
      if (!this.show) {
        setTimeout(() => {
          this.items = [];
          this.form = {
            ...this.emptyForm,
          };
        }, 200);
      } else if (Object.keys(this.group).length) {
        this.items = [
          ...this.group.items,
        ];
        this.globalConnector = this.group.connector;
      }
    },
  },
};
</script>

<style scoped>
/*
.filter-checkbox >>> .v-input__slot {
  margin-bottom: 0 !important;
}
.filter-checkbox >>> label {
  color: #000 !important;
}
*/
#save-button {
  min-width: unset;
}
.grey {
  background-color: #eee !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CollectWorkflows/Detail/WorkflowTree/FiltersList.vue